import type { StaticEntityType } from "@config";
import { useIsEditorContext } from "@editor-providers";
import type { CSSProperties } from "react";

export const SeparatorLibrary = ({
  entity,
  editorData,
}: {
  entity: StaticEntityType;
  editorData?: { height: string };
}) => {
  const isEditor = useIsEditorContext();
  const { settings } = entity as StaticEntityType<{ height: string }>;
  const height = editorData?.height || settings.height;
  return (
    <div
      className="tw-h-[var(--entity-height)]"
      {...EDITOR_ATTRIBUTES({ isEditor })}
      style={{ "--entity-height": `${height || 10}px` } as CSSProperties}
    ></div>
  );
};

const EDITOR_ATTRIBUTES = ({ isEditor }: { isEditor: boolean }) => {
  const payload: Record<string, string> = {
    "data-dnd-trigger": "true",
  };
  return isEditor ? payload : {};
};
